import producer from 'immer';
import {
  DELETE_PHOTO,
  FETCH_PHOTOS,
  UPDATE_LIST_PHOTOS,
  UPDATE_PHOTOS,
  UPDATE_DESCRIPTION_ON_PHOTO_LIST,
  HAS_FINISHED_PHOTOS_UPLOAD,
  HAS_STARTED_PHOTOS_UPLOAD,
  CHANGE_DROPZONE_VISIBILITY,
  UPDATE_HAS_SNACK_BAR,
  ADD_PHOTOS_TO_UPLOAD,
  UPDATE_MAIN_PHOTO,
  ROTATE_PHOTO,
  FETCH_ROOM_SUGGESTIONS,
} from './types';
import {
  handleAddPhotosToUpload,
  handleChangeDropZoneVisibility,
  handleDeletePhoto,
  handleFetchPhotos,
  handleUploadFilePhotos,
  handleUpdateListPhotos,
  handleUpdatePhotos,
  handleUpdateDescriptionOnPhotoList,
  handleUploadStart,
  handleUpdateHasSnackbar,
  handleUpdateMainPhoto,
  handleRotatePhotoClockwise,
  handleFetchRoomsSuggestions,
} from './handlers';

export const initialState = {
  photoList: [],
  photosToUpload: [],
  hasStartedFetchPhotos: true,
  hasFinishedFetchPhotos: true,
  hasNotDataUploadedBeenRetrived: false,
  hasNotInitialDataBeenRetrived: true,
  hasStartedPhotoUpload: false,
  hasFinishedPhotoUpload: true,
  loadingUpload: false,
  hasSnackbar: false,
  snackbarState: '',
  snackbarMessage: '',
  photoListDropzoneVisibility: false,
  roomsSuggestions: [],
};

export const photosManagerReducer = (state = initialState, action = undefined) => {
  switch (action.type) {
    case DELETE_PHOTO:
      return handleDeletePhoto(state, action);
    case FETCH_PHOTOS:
      return handleFetchPhotos(state, action);
    case HAS_FINISHED_PHOTOS_UPLOAD:
      return handleUploadFilePhotos(state, action);
    case UPDATE_LIST_PHOTOS:
      return handleUpdateListPhotos(state, action);
    case UPDATE_PHOTOS:
      return handleUpdatePhotos(state, action);
    case UPDATE_DESCRIPTION_ON_PHOTO_LIST:
      return handleUpdateDescriptionOnPhotoList(state, action);
    case HAS_STARTED_PHOTOS_UPLOAD:
      return handleUploadStart(state, action);
    case CHANGE_DROPZONE_VISIBILITY:
      return handleChangeDropZoneVisibility(state, action);
    case UPDATE_HAS_SNACK_BAR:
      return handleUpdateHasSnackbar(state, action);
    case ADD_PHOTOS_TO_UPLOAD:
      return handleAddPhotosToUpload(state, action);
    case UPDATE_MAIN_PHOTO:
      return handleUpdateMainPhoto(state, action);
    case ROTATE_PHOTO:
      return handleRotatePhotoClockwise(state, action);
    case FETCH_ROOM_SUGGESTIONS:
      return handleFetchRoomsSuggestions(state, action);
    default:
      return state;
  }
};

export default producer(photosManagerReducer);
